import {
  RESET_DAY_WISE_DAILY_TRANSACTION_SUMMARY,
  GET_DAY_WISE_DAILY_TRANSACTION_SUMMARY,
} from '../../../../Types'

const initialState = {
  data: [],
  totalRecords: 0
}

const DayWiseDailyTransactionsSummaryReducer = (state = initialState, action) => {
  switch (action.type) {

    case GET_DAY_WISE_DAILY_TRANSACTION_SUMMARY:
      return {
        ...state,
        data: action.payload.data,
        totalRecords: action.payload.totalRecords
      }

    case RESET_DAY_WISE_DAILY_TRANSACTION_SUMMARY:
      return initialState

    default:
      return state
  }
}

export default DayWiseDailyTransactionsSummaryReducer
